"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var CppObject_1 = require("./CppObject");

var Symbol_1 = require("./Symbol");

var instance_1 = require("./instance");

var Image = /*#__PURE__*/function (_CppObject_1$CppObjec) {
  _inherits(Image, _CppObject_1$CppObjec);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, _getPrototypeOf(Image).apply(this, arguments));
  }

  _createClass(Image, [{
    key: "destroy",
    value: function destroy() {
      this.checkAlive();
      this.inst.Image_destory(this.ptr);
      this.ptr = 0;
    }
  }, {
    key: "getSymbols",
    value: function getSymbols() {
      this.checkAlive();
      var res = this.inst.Image_get_symbols(this.ptr);
      return Symbol_1.Symbol.createSymbolsFromPtr(res, this.inst.memory.buffer);
    }
  }], [{
    key: "createFromGrayBuffer",
    value: function () {
      var _createFromGrayBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(width, height, dataBuf) {
        var sequence_num,
            inst,
            heap,
            data,
            len,
            buf,
            ptr,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sequence_num = _args.length > 3 && _args[3] !== undefined ? _args[3] : 0;
                _context.next = 3;
                return instance_1.getInstance();

              case 3:
                inst = _context.sent;
                heap = new Uint8Array(inst.memory.buffer);
                data = new Uint8Array(dataBuf);
                len = width * height;

                if (!(len !== data.byteLength)) {
                  _context.next = 9;
                  break;
                }

                throw Error('dataBuf does not match width and height');

              case 9:
                buf = inst.malloc(len);
                heap.set(data, buf);
                ptr = inst.Image_create(width, height, 0x30303859
                /* Y800 */
                , buf, len, sequence_num);
                return _context.abrupt("return", new this(ptr, inst));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createFromGrayBuffer(_x, _x2, _x3) {
        return _createFromGrayBuffer.apply(this, arguments);
      }

      return createFromGrayBuffer;
    }()
  }, {
    key: "createFromRGBABuffer",
    value: function () {
      var _createFromRGBABuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(width, height, dataBuf) {
        var sequence_num,
            inst,
            heap,
            data,
            len,
            buf,
            i,
            r,
            g,
            b,
            ptr,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sequence_num = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 0;
                _context2.next = 3;
                return instance_1.getInstance();

              case 3:
                inst = _context2.sent;
                heap = new Uint8Array(inst.memory.buffer);
                data = new Uint8Array(dataBuf);
                len = width * height;

                if (!(len * 4 !== data.byteLength)) {
                  _context2.next = 9;
                  break;
                }

                throw Error('dataBuf does not match width and height');

              case 9:
                buf = inst.malloc(len);

                for (i = 0; i < len; ++i) {
                  r = data[i * 4];
                  g = data[i * 4 + 1];
                  b = data[i * 4 + 2];
                  heap[buf + i] = r * 19595 + g * 38469 + b * 7472 >> 16;
                }

                ptr = inst.Image_create(width, height, 0x30303859
                /* Y800 */
                , buf, len, sequence_num);
                return _context2.abrupt("return", new this(ptr, inst));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createFromRGBABuffer(_x4, _x5, _x6) {
        return _createFromRGBABuffer.apply(this, arguments);
      }

      return createFromRGBABuffer;
    }()
  }]);

  return Image;
}(CppObject_1.CppObject);

exports.Image = Image;